module.exports = __webpack_public_path__ + "img/icon-ring-chart.c79d699d.png";